import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { FcpBreadcrumbsComponent } from './fcp-breadcrumbs.component';
import { FcpLinkModule } from '../fcp-link';

@NgModule({
    declarations: [FcpBreadcrumbsComponent],
    imports: [CommonModule, FcpLinkModule, RouterModule],
    exports: [FcpBreadcrumbsComponent]
})
export class FcpBreadcrumbsModule {}
